import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles";

export const entryTitleAndReportStyles = style({
  display: "grid",
  gap: vars.space.m,
});

export const entryTitleWrapperHeader = style({
  display: "flex",
  alignItems: "center",
  gap: vars.space.s,
  margin: "auto 0",
});
